import { useCallback, useEffect, useState, useRef } from 'react';
import {
    notification
} from 'antd';
import { useNavigate } from 'react-router-dom';

import { VerificaRota } from './../../../../../services/VerificaSePodeAcessar';
import { EmitirErro } from '../../../../../services/EmitirErro';
import { SairDoSistema } from '../../../../../services/LStorage/SairSistema';

import { validaDigitaçãoEFormataDinheiroBR } from '../../../../../services/Conversores';
import CertidoesService from '../../../../../services/http/services/CongelamentoPorCNPJ/CertidoesService';

interface IProps { id?: string };

export const useCertidoesAddOrUpdate = ({ id }: IProps) => {

    const navigate = useNavigate();

    const refForm = useRef<any>(null);

    const refAbortController = useRef<AbortController>();

    const [estaEditando, setEstaEditando] = useState(false);

    const [valorNumeroIdItem, setValorNumeroIdItem] = useState('');
    const [valorNumeroCusto, setValorNumeroCusto] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => () => {
        refAbortController.current?.abort();
    }, []);

    // useEffect(() => () => {

    //     let dadosLocalStorage: string | null = localStorage.getItem('@DesenvolveSP:configuracoesEditar');
    //     let localUserData: any = null;
    //     if (typeof dadosLocalStorage == 'string') {
    //         localUserData = JSON.parse(dadosLocalStorage);
    //     }

    //     if (localUserData) {
    //         localStorage.removeItem('@DesenvolveSP:configuracoesEditar');
    //     }

    // }, []);

    const buscaDadosCertidaoESetCampos = useCallback((id: string) => {

        const requestAsync = async () => {
            try {

                const response = await CertidoesService.getCertidoesById(id, refAbortController.current?.signal);

                if (response) {

                    refForm.current?.setFieldsValue(
                        {
                            nome: response.nome ? response.nome : undefined,
                            idItem: typeof response.idItem === 'number' ? response.idItem : undefined,
                            sigla: typeof response?.sigla ? response.sigla : undefined,
                            // custo: typeof response?.custo === 'number' ? convertMoedaBRDoJSNovo(response.custo) : undefined,
                            custo: typeof response?.custo === 'number' ? response.custo : undefined,
                        }
                    );
                }

            } catch (error) {
                let msgErro: any = (error as Error);

                if (msgErro?.message === 'USUáRIO NãO AUTORIZADO.') {
                    SairDoSistema();
                    notification.error({
                        message: 'Sessão expirada',
                        description:
                            'Sua sessão expirou, realize o login novamente!',
                    });
                    navigate('/');
                } else {
                    EmitirErro(error, true, 'addoredituser_dkwdfaiweyi')
                }


            }
        }

        requestAsync();

    }, []);

    useEffect(() => {

        let arrayUrl = window.location.pathname.split("/");
        VerificaRota(arrayUrl, navigate, true);

        if (typeof id === 'string') {
            if (id === 'criar') {
                setEstaEditando(false)
            } else {
                setEstaEditando(true)
                buscaDadosCertidaoESetCampos(id);
            }
        }


    }, []);

    const submitBotaoSalvar = useCallback(() => {

        const salvarDadosCriar = async (obj: any) => {
            try {
                setLoading(true);

                await CertidoesService.postCertidoes(obj, refAbortController.current?.signal);

                notification.success({
                    message: 'Sucesso',
                    description:
                        'Seus dados foram criados com sucesso!',
                });

                setLoading(false);

                navigate('/congelamento-cnpj/certidoes')

            } catch (error) {
                setLoading(false);
                let msgErro: any = (error as Error);

                if (msgErro?.message === 'USUáRIO NãO AUTORIZADO.') {
                    SairDoSistema();
                    notification.error({
                        message: 'Sessão expirada',
                        description:
                            'Sua sessão expirou, realize o login novamente!',
                    });
                    navigate('/');
                } else {
                    EmitirErro(error, true, 'addoredituser_dkwdfaiweyi')
                }


            }
        }

        refForm.current?.validateFields()
            .then((values: any) => {

                //converte dinheiro
                // let valorFormatUS = convertMoedaBRParaUS(values.custo)
                // values.custo = valorFormatUS ? valorFormatUS : null;
                values.idItem = Number(values.idItem);
                values.custo = Number(values.custo);

                salvarDadosCriar(values);

            })
            .catch((errorInfo: any) => {

                const fieldWithError = errorInfo.errorFields[0].name[0];
                refForm.current.getFieldInstance(fieldWithError).focus();

                notification.error({
                    message: 'Erro',
                    description:
                        'Preencha os campos obrigatórios!',
                });
            });


    }, []);

    const submitBotaoEditar = useCallback((idUser: string) => {


        const salvarDadosEditar = async (obj: any) => {
            try {
                setLoading(true);

                await CertidoesService.putCertidoes(idUser, obj, refAbortController.current?.signal);

                notification.success({
                    message: 'Sucesso',
                    description:
                        'Seus dados foram editados com sucesso!',
                });

                setLoading(false);
                navigate('/congelamento-cnpj/certidoes');

            } catch (error) {
                setLoading(false);
                let msgErro: any = (error as Error);

                if (msgErro?.message === 'USUáRIO NãO AUTORIZADO.') {
                    SairDoSistema();
                    notification.error({
                        message: 'Sessão expirada',
                        description:
                            'Sua sessão expirou, realize o login novamente!',
                    });
                    navigate('/');
                } else {
                    EmitirErro(error, true, 'addoredituser_dkwdfaiweyi')
                }


            }
        }

        refForm.current?.validateFields()
            .then((values: any) => {

                //converte dinheiro
                // let valorFormatUS = convertMoedaBRParaUS(values.custo)
                // values.custo = valorFormatUS ? valorFormatUS : null;
                values.idItem = Number(values.idItem);
                values.custo = Number(values.custo);

                salvarDadosEditar(values);

            })
            .catch((errorInfo: any) => {

                const fieldWithError = errorInfo.errorFields[0].name[0];
                refForm.current.getFieldInstance(fieldWithError).focus();

                notification.error({
                    message: 'Erro',
                    description:
                        'Preencha os campos obrigatórios!',
                });
            });


    }, []);

    const onChangeInputNumberNumero = useCallback((e: any) => {
        const originalValue = e.target.value;//+''
        const regex = /^[0-9\.]*$/

        if (regex.test(originalValue)) {
            setValorNumeroIdItem(originalValue)
            refForm.current.setFieldsValue(
                { idItem: originalValue }
            );
        }
        else {
            refForm.current.setFieldsValue(
                { idItem: valorNumeroIdItem }
            );
        }
    }, [valorNumeroIdItem]);

    const onChangeInputNumberNumeroCusto = useCallback((e: any) => {
        const originalValue = e.target.value;//+''
        const regex = /^[0-9\.]*$/

        if (regex.test(originalValue)) {
            setValorNumeroCusto(originalValue)
            refForm.current.setFieldsValue(
                { custo: originalValue }
            );
        }
        else {
            refForm.current.setFieldsValue(
                { custo: valorNumeroCusto }
            );
        }
    }, [valorNumeroCusto]);

    const onChangeInputFormatMoney = useCallback((e: any) => {

        refForm.current.setFieldsValue(
            { custo: validaDigitaçãoEFormataDinheiroBR(e.target.value) }
        );

    }, []);

    return {
        loading,
        estaEditando,
        navigate,
        refForm,
        onChangeInputNumberNumero,
        onChangeInputFormatMoney,
        submitBotaoEditar,
        submitBotaoSalvar,
        onChangeInputNumberNumeroCusto,
    }
}
